import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';

let axeConnected = false;
export const useAxe = (environment: string) => {
  useEffect(() => {
    if (typeof window === 'undefined') return;
    if ('Cypress' in window) return;
    if (environment !== 'local' && environment !== 'development') return;
    if (axeConnected) return;

    import('@axe-core/react')
      .then((axe) => {
        axe.default(React, ReactDOM, 1000);
      })
      .then(() => {
        axeConnected = true;
        console.log('@axe-core/react running');
      })
      .catch((error) => {
        console.error('Failed to run @axe-core/react', error);
      });
  }, [environment]);
};
